import React from 'react'
import {Step, StepLabel, Stepper} from '@mui/material'
import {ReservationClass} from '../ReservationInterfaces'

export enum AdminAgentReserveSteps {
    SELECT_FACILITY = '予約施設・日時選択',
    SELECT_USER = '利用者・支払方法選択',
    SELECT_OPTION = 'オプション選択',
    CONFIRM = '予約内容確認',
    COMPLETE = '予約完了',
}

export enum AdminManagerReserveSteps {
    SELECT_FACILITY = '予約施設・日時選択',
    SELECT_USER = '利用者選択',
    SELECT_OPTION = 'オプション選択',
    CONFIRM = '予約内容確認',
    COMPLETE = '予約完了',
}

interface CommonProps {
    hasOption: boolean
}

interface PropsForAgent {
    classification: ReservationClass.AGENT
    step: AdminAgentReserveSteps
}

interface PropsForManager {
    classification: ReservationClass.MANAGER
    step: AdminManagerReserveSteps
}

type Props = CommonProps & (PropsForAgent | PropsForManager)

export const AdminReserveStepper: React.FC<Props> = props => {
    const agentReservationStepLabelsWithOption: AdminAgentReserveSteps[] = [
        AdminAgentReserveSteps.SELECT_FACILITY,
        AdminAgentReserveSteps.SELECT_USER,
        AdminAgentReserveSteps.SELECT_OPTION,
        AdminAgentReserveSteps.CONFIRM,
        AdminAgentReserveSteps.COMPLETE,
    ]

    const agentReservationStepLabelsWithoutOption: AdminAgentReserveSteps[] = [
        AdminAgentReserveSteps.SELECT_FACILITY,
        AdminAgentReserveSteps.SELECT_USER,
        AdminAgentReserveSteps.CONFIRM,
        AdminAgentReserveSteps.COMPLETE,
    ]

    const managerReservationStepLabelsWithOption: AdminManagerReserveSteps[] = [
        AdminManagerReserveSteps.SELECT_FACILITY,
        AdminManagerReserveSteps.SELECT_USER,
        AdminManagerReserveSteps.SELECT_OPTION,
        AdminManagerReserveSteps.CONFIRM,
        AdminManagerReserveSteps.COMPLETE,
    ]

    const managerReservationStepLabelsWithoutOption: AdminManagerReserveSteps[] = [
        AdminManagerReserveSteps.SELECT_FACILITY,
        AdminManagerReserveSteps.SELECT_USER,
        AdminManagerReserveSteps.CONFIRM,
        AdminManagerReserveSteps.COMPLETE,
    ]

    let renderSteps: string[]
    let step: number
    if (props.classification === ReservationClass.AGENT) {
        if (props.hasOption) {
            renderSteps = agentReservationStepLabelsWithOption
        } else {
            renderSteps = agentReservationStepLabelsWithoutOption
        }

        if (props.step === AdminAgentReserveSteps.COMPLETE) {
            step = renderSteps.length
        } else {
            step = renderSteps.indexOf(props.step)
        }
    } else {
        if (props.hasOption) {
            renderSteps = managerReservationStepLabelsWithOption
        } else {
            renderSteps = managerReservationStepLabelsWithoutOption
        }

        if (props.step === AdminManagerReserveSteps.COMPLETE) {
            step = renderSteps.length
        } else {
            step = renderSteps.indexOf(props.step)
        }
    }

    return (
        <Stepper activeStep={step} alternativeLabel>
            {renderSteps.map((label, index) => (
                <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    )
}
